module.exports = __webpack_public_path__ + "static/media/Cats eyes 07_ENGELSKA-mixdown.63de42e5.mp3";